// import { WhichWeightAPI } from '../../WhichWeightAPI'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { Switch } from '@headlessui/react'

import ScreenFrame from 'components/Frame/ScreenFrame'
import WorkoutTemplateBuilder from 'components/WorkoutTemplateBuilder/WorkoutTemplateBuilder'

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function CreateWorkoutTemplate() {
    const navigate = useNavigate()

    const userId = useSelector((state) => state.user.id)

    const [mode, setMode] = useState('edit')

    const OnWorkoutBuilderModeToggle = () => {
        if (mode === 'edit') setMode('view')
        if (mode === 'view') setMode('edit')
    }

    // Post workout to the backend
    const postNewWorkout = async (phasedWorkout) => {
        console.log(JSON.stringify(phasedWorkout, null, 2))
    }

    // Posts a new program workout to the backend
    /*
    const postNewProgramWorkout = async (phasedWorkout) => {

        // console.log(JSON.stringify(phasedWorkout, null, 2));

        var jsonBody = {
            "programId": 4,
            "name": phasedWorkout.name,
            "version": phasedWorkout.version,
            "week": 1,
            "numberOfPhases": phasedWorkout.phases.length,
            "durationMinutes": 40,
            "phasedWorkoutJSON": phasedWorkout
        }

        console.log(jsonBody);

        const result = await WhichWeightAPI("CORE", "POST", "/program_workout_template", jsonBody);

        console.log(result);

        if (result == "failure") console.error(result);
        else navigate("/workout/template/list");

    };
    */

    return (
        <ScreenFrame>
            {/* Header */}
            <div className="flex items-center">
                <div className="flex-grow">
                    <h1 className="text-2xl font-semibold text-gray-900">Create Workout Template</h1>
                    <h2 className="text-1xl text-gray-900 mb-4">Create a workout template here</h2>
                </div>

                {/* View Mode Toggle Toggle */}
                <div className="flex">
                    <p className="pr-4 text-gray-500">View Mode: </p>

                    <Switch
                        checked={mode === 'view'}
                        onChange={() => OnWorkoutBuilderModeToggle()}
                        className={classNames(
                            mode === 'view' ? 'bg-orange-600' : 'bg-gray-200',
                            'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-orange-600 focus:ring-offset-2'
                        )}
                    >
                        <span className="sr-only">Use setting</span>

                        <span
                            aria-hidden="true"
                            className={classNames(
                                mode === 'view' ? 'translate-x-5' : 'translate-x-0',
                                'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out'
                            )}
                        />
                    </Switch>
                </div>
            </div>

            {/* Phased Workout Builder */}
            <WorkoutTemplateBuilder mode={mode} actionButtonText="Print Workout Template To Console" action={postNewWorkout} />
        </ScreenFrame>
    )
}
